module.exports = __webpack_public_path__ + "assets/img/business_license.dbd8934e.jpg";